<template>
  <div class="content_main">
    <template v-if="active == 'lis'">
      <a-tabs type="card" @change="callback">
        <a-tab-pane key="1" tab="年度考核">
          <div class="showPage content_main page_main o_s">
            <div class="item" v-for="(item, index) in exlist" :key="index">
              <div class="title">{{ item.trainYear }}年度—{{ item.examName }}</div>
              <div class="bot flex_sb_c">
                <div class="flex_st_c">
                  <div class="botItem"
                    :style="{ color: item.categoryListArr[0].color, border: '1px solid ' + item.categoryListArr[0].color}"
                    v-if="item.categoryListArr[0]">{{ item.categoryListArr[0].name }}</div>
                  <div class="botItem"
                    :style="{ color: item.categoryListArr[1].color, border: '1px solid ' + item.categoryListArr[1].color,}"
                    v-if="item.categoryListArr[1]">{{ item.categoryListArr[1].name }}</div>
                  <a-popover title="更多标签" trigger="click">
                    <template slot="content">
                      <div class="ant-popover-inner-content-self">
                        <div class="botItem" style="margin-bottom:8px" v-for="(tag, index) in item.categoryListArr"
                          :key="index" :style="{ color:tag.color, border:'1px solid '+tag.color }">
                          {{ tag.name }}</div>
                      </div>

                    </template>
                    <!-- <a-button type="primary">
                Hover me
              </a-button> -->
                    <a-icon class="aIco" type="info-circle" title="更多" v-if="item.categoryListArr.length > 2" />
                  </a-popover>
                </div>
                <div class="flex_e_c">
                  <div class="errBtn" v-if="item.status == 1" @click="examerr(index,1)">查看错题</div>
                  <div class="eBtn sueBtn" v-if="item.status == 2">已通过</div>
                  <div v-if="item.checked == 1">
                    <div class="eBtn" @click="create_gen(index)" v-if="item.status == 0">进入考试</div>
                    <div class="eBtn ereBtn" @click="create_gen(index)" v-if="item.status == 1">重新考试</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="课程考核">
          <div class="showPage content_main page_main o_s">
            <div class="item" v-for="(item, index) in myexlist" :key="index">
              <div class="title">{{ item.examName }}</div>
              <div class="bot flex_sb_c">
                <div class="flex_st_c">
                  <div class="botItem"
                    :style="{ color: item.categoryListArr[0].color, border: '1px solid ' + item.categoryListArr[0].color}"
                    v-if="item.categoryListArr[0]">{{ item.categoryListArr[0].name }}</div>
                  <div class="botItem"
                    :style="{ color: item.categoryListArr[1].color, border: '1px solid ' + item.categoryListArr[1].color,}"
                    v-if="item.categoryListArr[1]">{{ item.categoryListArr[1].name }}</div>
                  <a-popover title="更多标签" trigger="click">
                    <template slot="content">
                      <div class="ant-popover-inner-content-self">
                        <div class="botItem" style="margin-bottom:8px" v-for="(tag, index) in item.categoryListArr"
                          :key="index" :style="{ color:tag.color, border:'1px solid '+tag.color }">
                          {{ tag.name }}</div>
                      </div>

                    </template>
                    <!-- <a-button type="primary">F
                Hover me
              </a-button> -->
                    <a-icon class="aIco" type="info-circle" title="更多" v-if="item.categoryListArr.length > 2" />
                  </a-popover>
                </div>
                <div class="flex_e_c">
                  <div class="errBtn" v-if="item.status == 1" @click="examerr(index,2)">查看错题</div>
                  <div class="eBtn sueBtn" v-if="item.status == 2">已通过</div>
                  <div v-if="item.checked == 1">
                    <div class="eBtn" @click="create_gen_edit(index)" v-if="item.status == 0">进入考试</div>
                    <div class="eBtn ereBtn" @click="create_gen_edit(index)" v-if="item.status == 1">重新考试</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </template>
    <div class="content_main page_main page_color" v-if="active == 'rate'" ref="full" id="start">
      <div class="hite">考试需在全屏下进行，退出全屏或切换窗口将立即交卷！</div>
      <div class="flexFixd" v-if="showFixd">
        <div class="fc">
          <div class="title">提示</div>
          <div class="content">{{ msg }}</div>
          <div class="btns">
            <div class="btn" @click="sumbit(2)">提交 ( {{ nxtime }} )</div>
          </div>
        </div>
      </div>
      <div class="flexFixd" v-if="showFixd2">
        <div class="fc">
          <div class="title">提示</div>
          <div class="content">还有题目没有作答，是否现在交卷？</div>
          <div class="btns">
            <div class="btn" @click="sumbitLis">交卷</div>
            <div class="btnb" @click="calcel">取消</div>
          </div>
        </div>
      </div>
      <div class="page_main" v-if="pageModul == 'gen'">
        <div class="pageHead">
          <div class="htitle">{{ exrow.trainYear }}年度—{{ exrow.examName }}</div>
          <div class="htime">倒计时: {{ timeMsg }}</div>
          <div class="sbtn" @click="sumbit(1)">交卷</div>
        </div>
        <div class="pageContent">
          <div class="content_l">
            <div class="ltitle">目录</div>
            <div class="lc">
              <div class="l_box" v-if="single.length">
                <div class="boxtitle">单选题</div>
                <div :class="type == 'single' && sindex == index ? 'activeRowName rowName' : 'rowName'"
                  v-for="(item, index) in single" :key="index" @click="changeSort(index, 'single')">
                  <div :class="item.answer ? 'brage brageHave' : 'brage'"></div>
                  第{{ item.sort }}题
                </div>
              </div>
              <div class="l_box" v-if="multi.length">
                <div class="boxtitle">多选题</div>
                <div :class="type == 'multi' && sindex == index ? 'activeRowName rowName' : 'rowName'"
                  v-for="(item, index) in multi" :key="index" @click="changeSort(index, 'multi')">
                  <div :class="item.answer != undefined ? 'brage brageHave' : 'brage'"></div>
                  第{{ item.sort }}题
                </div>
              </div>
              <div class="l_box" v-if="judge.length">
                <div class="boxtitle">判断题</div>
                <div class="rowName" :class="type == 'judge' && sindex == index ? 'activeRowName rowName' : 'rowName'"
                  v-for="(item, index) in judge" :key="index" @click="changeSort(index, 'judge')">
                  <div :class="item.answer ? 'brage brageHave' : 'brage'"></div>
                  第{{ item.sort }}题
                </div>
              </div>
            </div>
          </div>
          <div class="content_r" v-if="detail != null">
            <div class="rtitle">
              <span v-if="type == 'single'">单选题</span><span v-if="type == 'multi'">多选题</span><span
                v-if="type == 'judge'">判断题</span> — 第{{ sindex + 1 }}题题干
            </div>
            <div class="rTop">
              <div class="rTopName">
                {{ detail.content }}
              </div>
              <div class="rTopImgs">
                <div class="imgBox" v-for="(item, index) in detail.imgList" :key="index">
                  <div class="imgm"></div>
                  <div class="imgc">
                    <img :src="item.preUrl" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="rtitle">
              <span v-if="type == 'single'">单选题</span><span v-if="type == 'multi'">多选题</span><span
                v-if="type == 'judge'">判断题</span> — 第{{ sindex + 1 }}题选项
            </div>
            <div class="rBot">
              <div class="radio" v-if="type == 'single'">
                <a-radio-group v-model="detail.answer" size="large">
                  <a-radio :value="item.sortField" v-for="(item, index) in detail.optionInfos" :key="index">
                    {{ item.sortField }}.{{ item.content }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="multi" v-if="type == 'multi'">
                <a-checkbox-group v-model="detail.answer">
                  <a-checkbox :value="item.sortField" v-for="(item, index) in detail.optionInfos" :key="index">
                    {{ item.sortField }}.{{ item.content }}
                  </a-checkbox>
                </a-checkbox-group>
              </div>
              <div class="radio" v-if="type == 'judge'">
                <a-radio-group v-model="detail.answer" size="large">
                  <a-radio :value="item.value" v-for="(item, index) in optionInfos" :key="index">
                    {{ item.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_main page_main page_color flexcol" v-if="pageModul == 'success'">
        <div class="stitle" style="color: #67c23a">恭喜您，考试通过！</div>
        <img class="simg" src="../../../assets/image/suc.png" alt="" />
        <div class="sname">{{ exrow.trainYear }}年度—{{ exrow.examName }}</div>
        <div class="stotal">总分:{{totalScore}}</div>
        <div class="stotal">
          我的得分: <span style="color: #67c23a">{{ stotal }}</span>
        </div>
        <div class="sbtn" @click="backlog">我知道了</div>
      </div>
      <div class="content_main page_main page_color flexcol" v-if="pageModul == 'err'">
        <div class="stitle" style="color: #f56c6c">很遗憾，未通过考试！</div>
        <img class="simg" src="../../../assets/image/er.png" alt="" />
        <div class="sname">{{ exrow.trainYear }}年度—{{ exrow.examName }}</div>
        <div class="stotal">总分:{{totalScore}}</div>
        <div class="stotal">
          我的得分: <span style="color: #f56c6c">{{ stotal }}</span>
        </div>
        <div class="srow">
          <div class="sbtn2" @click="lookerr">查看错题</div>
          <div class="sbtn3" @click="backlog">返回</div>
        </div>
      </div>
    </div>
    <div class="content_main page_main page_color" v-if="active == 'error'">
      <div class="page_main">
        <div class="pageHead" style="justify-content: space-between">
          <div class="htitle">{{ errItem.trainYear }}年度—{{ errItem.examName }}错题</div>
          <div class="sbtn" @click="quit">退出</div>
        </div>
        <div class="pageContent">
          <div class="content_l">
            <div class="ltitle">目录</div>
            <div class="lc">
              <div class="l_box">
                <div :class="sindexerr == index ? 'activeRowName rowName' : 'rowName'" v-for="(item, index) in errlis"
                  :key="index" @click="changeSortErr(index)">
                  <div :class="item.answer ? 'brage brageHave' : 'brage'"></div>
                  第{{ index + 1 }}题
                </div>
              </div>
            </div>
          </div>
          <div class="content_r" v-if="detailerr != null">
            <div class="rtitle">
              <span v-if="typeerr == 1">单选题</span><span v-if="typeerr == 2">多选题</span><span
                v-if="typeerr == 3">判断题</span> — 第{{ sindexerr + 1 }}题题干
            </div>
            <div class="rTop">
              <div class="rTopName">
                {{ detailerr.content }}
              </div>
              <div class="rTopImgs">
                <div class="imgBox" v-for="(item, index) in detailerr.imgList" :key="index">
                  <div class="imgm"></div>
                  <div class="imgc">
                    <img :src="item.preUrl" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="rtitle">
              <span v-if="typeerr == 1">单选题</span><span v-if="typeerr == 2">多选题</span><span
                v-if="typeerr == 3">判断题</span> — 第{{ sindexerr + 1 }}题选项
            </div>
            <div class="rBot">
              <div class="radio" v-if="typeerr == 1">
                <a-radio-group v-model="detailerr.answer">
                  <a-radio disabled :value="item.sortField" v-for="(item, index) in detailerr.optionInfos" :key="index">
                    {{ item.sortField }}.{{ item.content }}
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="multi" v-if="typeerr == 2">
                <a-checkbox-group disabled v-model="detailerr.answer">
                  <a-checkbox :value="item.sortField" v-for="(item, index) in detailerr.optionInfos" :key="index">
                    {{ item.sortField }}.{{ item.content }}
                  </a-checkbox>
                </a-checkbox-group>
              </div>
              <div class="radio" v-if="typeerr == 3">
                <a-radio-group v-model="detailerr.answer">
                  <a-radio disabled :value="item.value" v-for="(item, index) in optionInfos" :key="index">
                    {{ item.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { examlis, generate, generate_info, generate_submit, examlis_err } from '@/api/question'
import { myexam_list, tra_question_custom, submit_costom } from '@/api/course'
export default {
  data() {
    return {
      exlist: [],
      myexlist: [],
      active: 'lis',
      pageModul: 'gen',
      categoryId: '',
      single: [], //单选
      multi: [], //多选
      judge: [], //判断
      timeMsg: '', //倒计时文本
      checked: false,
      sindex: 0,
      type: '',
      detail: null,
      fullscreen: false, //是否全屏
      optionInfos: [
        { value: 1, label: '正确' },
        { value: 2, label: '错误' },
      ],
      showFixd: false, //计时结束
      msg: '',
      tover: null,
      nxtime: 5, //时间结束倒计时
      vartt: null, //倒计时
      stotal: 0, //自己总分
      showFixd2: false,
      query: '',
      status: { 0: '未开始', 1: '已通过', 2: '未通过' },
      errlis: [], //错题
      detailerr: null,
      typeerr: '',
      sindexerr: 0,
      errItem: '',
      exrow: '', //考试信息
      errIdxItem: 0,
      genType: 1,
      totalScore: 100,
    }
  },
  mounted() {
    this.getlis()
    this.getmylis()
  },
  methods: {
    callback(key) {
      if (key == 1) {
        this.getlis()
      } else if (key == 2) {
        this.getmylis()
      }
    },
    //获取我的考试(课程考核)
    getmylis() {
      myexam_list().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        var lis = res.data.list;
        lis.forEach(item => {
          item['categoryListArr'] = []
          var arr = item.categoryList ? item.categoryList.split(',') : [];
          arr.forEach(em => {
            var cs = em.split('@');
            item['categoryListArr'].push({
              name: cs[0],
              color: cs[1]
            })
          })

        })
        this.myexlist = lis
      })
    },
    //获取我的考试(年度考核)
    getlis() {
      examlis().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        var lis = res.data;
        lis.forEach(item => {
          item['categoryListArr'] = []
          var arr = item.categoryList ? item.categoryList.split(',') : [];
          arr.forEach(em => {
            var cs = em.split('@');
            item['categoryListArr'].push({
              name: cs[0],
              color: cs[1]
            })
          })

        })
        this.exlist = lis
      })
    },
    //生成试卷
    create_gen(idx) {
      this.genType = 1
      this.exrow = this.exlist[idx]
      this.errItem = this.exlist[idx]
      this.categoryId = this.exlist[idx].trainId;
      this.errIdxItem = idx
      generate({
        categoryId: this.categoryId,
        examId: this.exlist[idx].id
      }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        res.data.single.forEach((item) => {
          item['answer'] = undefined
        })
        if (!res.data.single.length) {
          if (!res.data.multi.length) {
            if (!res.data.judge.length) {
            } else {
              this.type = 'judge'
              this.get_info(res.data.judge[0].id)
            }
          } else {
            this.type = 'multi'
            this.get_info(res.data.multi[0].id)
          }
        } else {
          this.type = 'single'
          this.get_info(res.data.single[0].id)
        }
        this.single = res.data.single
        res.data.multi.forEach((item) => {
          item['answer'] = undefined
        })
        this.multi = res.data.multi
        res.data.judge.forEach((item) => {
          item['answer'] = undefined
        })
        this.judge = res.data.judge
        this.active = 'rate'
        this.pageModul = 'gen'
        this.setIntTime()
        this.$nextTick(() => {
          let element = this.$refs.full
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen()
          }
          var _this = this
          window.onblur = function (e) {
            _this.keyWordsumbitLis()
          }
          document.addEventListener('fullscreenchange', exitHandler, false)
          document.addEventListener('webkitfullscreenchange', exitHandler, false)
          document.addEventListener('mozfullscreenchange', exitHandler, false)
          document.addEventListener('MSFullscreenChange', exitHandler, false)
          function exitHandler(e) {
            console.log(e)
            if (document.fullscreenElement) {
              console.log('进入全屏')
            } else {
              console.log('退出全屏')
              console.log(_this.pageModul)
              if (_this.pageModul == 'gen') {
                _this.keyWordsumbitLis()
              }
            }
          }
        })
        this.fullscreen = true
      })
    },
    //自定义试卷
    create_gen_edit(idx) {
      this.genType = 2
      this.exrow = this.myexlist[idx]
      this.errItem = this.myexlist[idx]
      this.categoryId = this.myexlist[idx].trainId;
      this.errIdxItem = idx
      tra_question_custom({
        categoryId: this.categoryId,
        examId: this.myexlist[idx].examId
      }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        res.data.single.forEach((item) => {
          item['answer'] = undefined
        })
        if (!res.data.single.length) {
          if (!res.data.multi.length) {
            if (!res.data.judge.length) {
            } else {
              this.type = 'judge'
              this.get_info(res.data.judge[0].id)
            }
          } else {
            this.type = 'multi'
            this.get_info(res.data.multi[0].id)
          }
        } else {
          this.type = 'single'
          this.get_info(res.data.single[0].id)
        }
        this.single = res.data.single
        res.data.multi.forEach((item) => {
          item['answer'] = undefined
        })
        this.multi = res.data.multi
        res.data.judge.forEach((item) => {
          item['answer'] = undefined
        })
        this.judge = res.data.judge
        this.active = 'rate'
        this.pageModul = 'gen'
        this.setIntTime()
        this.$nextTick(() => {
          let element = this.$refs.full
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen()
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen()
          }
          var _this = this
          window.onblur = function (e) {
            _this.keyWordsumbitLis()
          }
          document.addEventListener('fullscreenchange', exitHandler, false)
          document.addEventListener('webkitfullscreenchange', exitHandler, false)
          document.addEventListener('mozfullscreenchange', exitHandler, false)
          document.addEventListener('MSFullscreenChange', exitHandler, false)
          function exitHandler(e) {
            console.log(e)
            if (document.fullscreenElement) {
              console.log('进入全屏')
            } else {
              console.log('退出全屏')
              console.log(_this.pageModul)
              if (_this.pageModul == 'gen') {
                _this.keyWordsumbitLis()
              }
            }
          }
        })
        this.fullscreen = true
      })
    },
    //考试倒计时
    setIntTime() {
      var counttime = 90 * 60 //一个小时，按秒计算，自己调整!
      var _this = this
      function clactime() {
        if (counttime >= 0) {
          var ms = counttime % 60 //余数 89%60==29秒
          var mis = Math.floor(counttime / 60) //分钟
          if (mis >= 60) {
            var hour = Math.floor(mis / 60)
            mis = Math.floor((counttime - hour * 60 * 60) / 60)
            _this.timeMsg = hour + ' 小时 ' + mis + ' 分 ' + ms + ' 秒 '
          } else if (mis >= 1) {
            _this.timeMsg = mis + ' 分 ' + ms + ' 秒 '
          } else {
            _this.timeMsg = ms + ' 秒 '
          }
          counttime--
          _this.vartt = setTimeout(() => {
            clactime()
          }, 1000)
        } else {
          clearTimeout(_this.vartt)
          _this.showFixd = true
          _this.nxtime = 5
          _this.msg = '考试时间结束,将在' + _this.nxtime + '秒后自动提交试卷！'
          _this.tover = setInterval(() => {
            if (_this.nxtime == 0) {
              clearInterval(_this.tover)
              _this.sumbit(2)
            } else {
              _this.nxtime -= 1
              _this.msg = '考试时间结束,将在 ' + _this.nxtime + ' 秒后自动提交试卷！'
            }
          }, 1000)
        }
      }
      clactime()
    },
    //切换题
    changeSort(idx, type) {
      switch (this.type) {
        case 'single':
          this.single[this.sindex].answer = this.detail.answer
          break
        case 'multi':
          this.multi[this.sindex].answer = this.detail.answer
          break
        case 'judge':
          this.judge[this.sindex].answer = this.detail.answer
          break
      }
      if (this.sindex != idx || this.type != type) {
        this.sindex = idx
        this.type = type
        var lis = ''
        switch (type) {
          case 'single':
            lis = this.single
            var nanswer = this.single[this.sindex].answer
            break
          case 'multi':
            var nanswer = this.multi[this.sindex].answer
            lis = this.multi
            break
          case 'judge':
            var nanswer = this.judge[this.sindex].answer
            lis = this.judge
            break
        }
        var id = lis[idx].id
        this.get_info(id, type, nanswer)
      }
    },
    //查询题目详情
    get_info(id, type, answer) {
      this.detail = null;
      generate_info({ id: id }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }

        this.detail = res.data
        this.detail.answer = answer
      })
    },
    //交卷
    sumbit(isTimeOver) {
      this.genType
      switch (this.type) {
        case 'single':
          this.single[this.sindex].answer = this.detail.answer
          break
        case 'multi':
          this.multi[this.sindex].answer = this.detail.answer
          break
        case 'judge':
          this.judge[this.sindex].answer = this.detail.answer
          break
      }
      var is = 1
      var list = []
      this.single.forEach((item) => {
        if (item.answer == undefined) {
          is = 0
        }
        list.push({
          id: item.id,
          answer: item.answer ? item.answer : '',
        })
      })
      this.multi.forEach((item) => {
        if (item.answer == undefined) {
          is = 0
        }
        list.push({
          id: item.id,
          answer: item.answer ? item.answer.join(';') : '',
        })
      })
      this.judge.forEach((item) => {
        if (item.answer == undefined) {
          is = 0
        }
        list.push({
          id: item.id,
          answer: item.answer ? item.answer : '',
        })
      })
      let query = {}
      if (this.genType == 1) {
        query = {
          answers: list,
          examId: this.exrow.id,
        }
      } else if (this.genType == 2) {
        query = {
          answers: list,
          examId: this.exrow.examId,
        }
      }
      var _this = this
      if (isTimeOver == 2) {
        this.sumbitGen(query)
      } else {
        if (!is) {
          this.showFixd2 = true
          this.query = query
        } else {
          this.sumbitGen(query)
        }
      }
    },
    calcel() {
      this.showFixd2 = false
    },
    //未答完交卷
    sumbitLis() {
      this.sumbitGen(this.query)
    },
    //按键交卷
    keyWordsumbitLis() {
      switch (this.type) {
        case 'single':
          this.single[this.sindex].answer = this.detail.answer
          break
        case 'multi':
          this.multi[this.sindex].answer = this.detail.answer
          break
        case 'judge':
          this.judge[this.sindex].answer = this.detail.answer
          break
      }
      var list = []
      this.single.forEach((item) => {
        list.push({
          id: item.id,
          answer: item.answer ? item.answer : '',
        })
      })
      this.multi.forEach((item) => {
        list.push({
          id: item.id,
          answer: item.answer ? item.answer.join(';') : '',
        })
      })
      this.judge.forEach((item) => {
        list.push({
          id: item.id,
          answer: item.answer ? item.answer : '',
        })
      })
      if (this.genType == 1) {
        query = {
          answers: list,
          examId: this.exrow.id,
        }
      } else if (this.genType == 2) {
        query = {
          answers: list,
          examId: this.exrow.examId,
        }
      }
      clearTimeout(this.vartt)
      clearInterval(this.tover)
      if (this.genType == 1) {
        generate_submit(query).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          window.onblur = undefined
          this.showFixd = false
          this.showFixd2 = false
          this.stotal = 100
          this.stotal = res.data.score
          if (res.data.level == 1) {
            this.pageModul = 'success'
          } else {
            this.pageModul = 'err'
          }
        })
      } else if (this.genType == 2) {
        submit_costom(query).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          window.onblur = undefined
          this.showFixd = false
          this.showFixd2 = false
          this.stotal = res.data.score
          this.totalScore = res.data.total
          if (res.data.level == 1) {
            this.pageModul = 'success'
          } else {
            this.pageModul = 'err'
          }
        })
      }
    },
    //提交试卷
    sumbitGen(query) {
      clearTimeout(this.vartt)
      clearInterval(this.tover)
      if (this.genType == 1) {
        generate_submit(query).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.totalScore = 100
          window.onblur = undefined
          this.showFixd = false
          this.showFixd2 = false
          this.stotal = 100
          if (res.data.level == 1) {
            this.pageModul = 'success'
          } else {
            this.pageModul = 'err'
          }
        })
      } else if (this.genType == 2) {
        submit_costom(query).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          window.onblur = undefined
          this.showFixd = false
          this.showFixd2 = false
          this.stotal = res.data.score
          this.totalScore = res.data.total
          if (res.data.level == 1) {
            this.pageModul = 'success'
          } else {
            this.pageModul = 'err'
          }
        })
      }
    },
    //返回
    backlog() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
      this.fullscreen = false;
      this.getlis()
      setTimeout(() => {
        this.active = 'lis';
      }, 600)
    },
    //查看错题
    examerr(idx, type) {
      let params = {}
      if (type == 2) {
        params.examId = this.myexlist[idx].examId
        this.errItem = this.myexlist[idx]
      } else {
        this.errItem = this.exlist[idx]
      }
      // var trainId = this.exlist[idx].trainId
      examlis_err(params).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.sindexerr = 0
        this.errlis = res.data
        this.active = 'error'
        this.changeSortErr(0)
      })
    },
    //考试结束查看错题
    lookerr() {
      this.examerr(this.errIdxItem, this.genType)
    },
    //查看错题详情
    changeSortErr(idx) {
      generate_info({ id: this.errlis[idx].questionId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.sindexerr = idx
        this.typeerr = res.data.type
        this.detailerr = res.data
        switch (res.data.type) {
          case 1 || 3:
            this.detailerr.answer = this.errlis[idx].answer
            break
          case 2:
            this.detailerr.answer = this.errlis[idx].answer ? this.errlis[idx].answer.split(';') : []
            break
        }
        // this.detail.answer = answer
      })
    },
    //退出错题
    quit() {
      this.active = 'lis'
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .ant-tabs-tabpane-active {
  height: 100% !important;
  padding: 10px 0;
}
::v-deep .ant-radio-disabled .ant-radio-inner {
  background-color: #f5000012;
  border-color: #f00 !important;
}

::v-deep .ant-radio-disabled + span {
  color: #160202 !important;
}

::v-deep .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5000012;
  border-color: #f00 !important;
}

::v-deep .ant-checkbox-disabled + span {
  color: #160202 !important;
}

:-webkit-full-screen .header {
  display: none !important;
}

:-moz-full-screen .header {
  display: none !important;
}

:-ms-fullscreen .header {
  display: none !important;
}

:fullscreen .header {
  display: none !important;
}

::v-deep .ant-radio-group {
  width: 100%;

  .ant-radio-wrapper {
    width: 100%;
    margin-bottom: 5px;
  }
}

::v-deep .ant-checkbox-group {
  width: 100%;

  .ant-checkbox-wrapper {
    width: 100%;
    margin-bottom: 5px;
    margin-left: 0;
  }
}

.ant-popover-inner-content-self {
  max-width: 400px;
  float: left;
  background: #fff;
}

.flexFixd {
  width: 100vw;
  height: 100vh;
  background: #0000005d;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .fc {
    width: 360px;
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius: 5px;

    .title {
      width: 100%;
      font-weight: 600;
      line-height: 40px;
    }

    .btns {
      width: 100%;
      float: left;
      margin: 15px 0;

      .btnb {
        padding: 4px 20px;
        float: right;
        border: 1px solid #ddd;
        box-sizing: border-box;
        border-radius: 5px;
        margin-right: 15px;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          background: #eee;
        }
      }

      .btn {
        padding: 5px 20px;
        float: right;
        background: #409eff;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          background: #40a0ffb6;
        }
      }
    }
  }
}

.brageHave {
  background: #67c23a !important;
}

.page_color {
  background: #eee;
  position: relative;

  .hite {
    position: absolute;
    top: 15px;
    width: 100%;
    color: red;
    text-align: center;
    font-size: 22px;
  }
}

.activeRowName {
  background: #57abff !important;
  color: #fff !important;
}

.flexcol {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .stitle {
    font-size: 26px;
    margin-top: 180px;
    font-weight: 600;
    margin-bottom: 30px;
  }

  .simg {
    width: 170px;
    margin-bottom: 30px;
  }

  .sname {
    font-size: 18px;
    color: #000;
    margin-bottom: 20px;
  }

  .stotal {
    font-size: 16px;

    span {
      font-weight: 600;
    }
  }

  .sbtn {
    width: 140px;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    background: #67c23a;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    margin-top: 40px;

    &:hover {
      background: #67c23abe;
    }
  }

  .srow {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sbtn2 {
    width: 140px;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    background: #f56c6c;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    margin-top: 40px;

    &:hover {
      background: #f56c6cb9;
    }
  }

  .sbtn3 {
    width: 140px;
    line-height: 40px;
    border-radius: 5px;
    border: 1px solid #ddd;
    background: #f2f2f2;
    text-align: center;
    cursor: pointer;
    transition: 0.3s;
    margin-top: 40px;
    margin-left: 40px;

    &:hover {
      background: #ddd;
    }
  }
}

.page_main {
  padding: 1px 10px !important;
  width: 100%;
  height: 100%;
  float: left;
  padding: 0 10px;
  box-sizing: border-box;

  .pageHead {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;

    .htitle {
      float: left;
      font-size: 26px;
      font-weight: 600;
      color: #333;
      width: calc(100% - 200px - 130px - 30px);
    }

    .htime {
      float: left;
      width: 200px;
      text-align: center;
      font-size: 16px;
    }

    .sbtn {
      float: left;
      width: 130px;
      text-align: center;
      cursor: pointer;
      line-height: 38px;
      background: #409eff;
      color: #fff;
      border-radius: 5px;
      margin-left: 30px;
    }
  }

  .pageContent {
    width: 100%;
    height: calc(100% - 80px);
    float: left;

    .content_l {
      width: 20%;
      height: 100%;
      float: left;

      .ltitle {
        width: 100%;
        float: left;
        font-size: 14px;
        line-height: 50px;
        color: #333;
        font-weight: 600;
      }

      .lc {
        width: 100%;
        height: calc(100% - 50px);
        float: left;
        background: #fff;
        border-radius: 10px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 8px; //对垂直方向滚动条
          height: 6px; //对水平方向滚动条
        }

        //滚动的滑块
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background-color: #ddd //滚动条的颜色;;
        }

        //内层滚动槽
        &::-webkit-scrollbar-track-piece {
          background-color: #eee;
        }

        .l_box {
          width: 100%;
          float: left;

          .boxtitle {
            width: 100%;
            float: left;
            font-size: 20px;
            font-weight: 600;
            color: #333;
            line-height: 50px;
            padding-left: 30px;
            box-sizing: border-box;
          }

          .rowName {
            width: 100%;
            float: left;
            font-size: 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 30px;
            box-sizing: border-box;
            height: 50px;
            color: #333;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
              background: #94c9fe;
              color: #fff;
            }

            .brage {
              width: 18px;
              height: 18px;
              background: #999;
              border-radius: 50%;
              float: left;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .content_r {
      width: calc(80% - 30px);
      height: 100%;
      float: right;

      .rtitle {
        width: 100%;
        float: left;
        font-size: 14px;
        line-height: 50px;
        color: #333;
        font-weight: 600;
      }

      .rTop {
        width: 100%;
        height: calc((100% - 100px) / 2);
        float: left;
        background: #fff;
        padding: 10px 25px;
        box-sizing: border-box;
        border-radius: 10px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 8px; //对垂直方向滚动条
          height: 6px; //对水平方向滚动条
        }

        //滚动的滑块
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background-color: #ddd //滚动条的颜色;;
        }

        //内层滚动槽
        &::-webkit-scrollbar-track-piece {
          background-color: #eee;
        }

        .rTopName {
          width: 100%;
          float: left;
          font-size: 16px;
          color: #333;
        }

        .rTopImgs {
          width: 100%;
          float: left;
          margin-top: 20px;

          .imgBox {
            width: calc(100% / 8 - 10px);
            position: relative;
            float: left;
            border-radius: 5px;
            overflow: hidden;
            cursor: pointer;
            margin-right: calc(80px / 7);
            margin-bottom: 10px;

            &:nth-child(8n) {
              margin-right: 0;
            }

            .imgm {
              margin-top: 100%;
            }

            .imgc {
              width: 100%;
              height: 100%;
              float: left;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;

              img {
                width: 100%;
                height: 100%;
                float: left;
                object-fit: contain;
              }
            }
          }
        }
      }

      .rBot {
        width: 100%;
        height: calc((100% - 100px) / 2);
        float: left;
        background: #fff;
        padding: 10px 25px;
        box-sizing: border-box;
        border-radius: 10px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          width: 8px; //对垂直方向滚动条
          height: 6px; //对水平方向滚动条
        }

        //滚动的滑块
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          background-color: #ddd //滚动条的颜色;;
        }

        //内层滚动槽
        &::-webkit-scrollbar-track-piece {
          background-color: #eee;
        }
      }
    }
  }
}

.botItem {
  float: left;
  margin-right: 8px;
  border-radius: 5px;
  padding: 4px 7px;
}

.item {
  width: calc(50% - 12px);
  float: left;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
  margin-right: 24px;
  box-shadow: 0 0 10px #afafaf;

  &:nth-child(2n) {
    margin-right: 0;
  }

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    float: left;
    width: 100%;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
  }

  .bot {
    width: 100%;
    float: left;
    margin-top: 15px;

    .aIco {
      cursor: pointer;
      font-size: 24px;
      color: #ff9b73;
    }
  }

  .time {
    float: left;
    width: 170px;
    text-align: center;
    font-size: 16px;

    .t {
      color: #f56c6c;
      padding: 0 6px;
    }
  }

  .errBtn {
    float: left;
    width: 120px;
    border-radius: 5px;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #f56c6c;
  }

  .sueBtn {
    float: left;
    width: 120px;
    border-radius: 5px;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #67c23a !important;
    background: #67c23a;
    color: #fff !important;
    transition: 0.3s;
    margin-left: 15px;
  }

  .ereBtn {
    float: left;
    width: 120px;
    border-radius: 5px;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #e6a23c !important;
    color: #e6a23c !important;
    transition: 0.3s;
    margin-left: 15px;

    &:hover {
      background: #e6a23c !important;
      color: #fff !important;
    }
  }

  .eBtn {
    float: left;
    width: 120px;
    border-radius: 5px;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #409eff;
    color: #409eff;
    transition: 0.3s;
    margin-left: 15px;

    &:hover {
      background: #409eff;
      color: #fff;
    }
  }
}
</style>>

